import React from 'react';

export function BinActivation(props) {
  return (
    <a className={`bin-activation ${props.activeClassName}`}
      title={props.activeClassName ? 'Activate' : 'Deactivate'}
      onClick={e => {
        e.preventDefault();
        props.onChange();
      }}>
      <i className="fa fa-check"/>
    </a>
  );
}
